<template>
    <rkm-area
        no-margin-top
        title="Agendamentos"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-date-picker
                        :end-validations="validations.periodo"
                        :range-inline="false"
                        :start-validations="validations.periodo"
                        end-label="Até"
                        range
                        start-label="Período de"
                        v-model="model.periodo"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :validations="validations.inicio"
                        label="Hora inicial"
                        v-model="model.inicio"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :validations="validations.fim"
                        label="Hora final"
                        right
                        v-model="model.fim"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        @change="handleUnidadeChange"
                        default-option-text="Todas"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="form.infraestruturas"
                        @change="handleInfraestruturaChange"
                        default-option-text="Todos"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.ocupacoes"
                        @change="handleOcupacaoChange"
                        default-option-text="Todos"
                        label="CBO"
                        show-default-option
                        text-field="descricao"
                        v-model="model.ocupacaoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.especialidades"
                        @change="handleEspecialidadeChange"
                        default-option-text="Todas"
                        label="Especialidade"
                        show-default-option
                        text-field="nome"
                        v-model="model.especialidadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.usuarios"
                        @change="handleUsuarioChange"
                        default-option-text="Todos"
                        label="Profissional"
                        show-default-option
                        text-field="nome"
                        v-model="model.usuarioId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.tipos"
                        @change="handleJornadaVagaTipoChange"
                        default-option-text="Todos"
                        label="Tipo de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.tipoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.status"
                        @change="handleStatusChange"
                        default-option-text="Todos"
                        label="Status"
                        show-default-option
                        text-field="nome"
                        v-model="model.statusId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="search"
                        color="primary"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clean"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-area>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                inicio: {required: !!this.model.fim},
                fim: {required: !!this.model.inicio},
            }
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('ambulatorio.agendamento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUnidadeChange(value) {
            this.$emit('cleaned', [])

            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.tipos = []
            this.form.status = []
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.tipoId = null
            this.model.statusId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'infraestruturas',
                pacienteId: this.pacienteId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.tipos = Object.assign(response.data.tipos)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.$emit('cleaned', [])

            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.tipos = []
            this.form.status = []
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.tipoId = null
            this.model.statusId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'usuarios',
                pacienteId: this.pacienteId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.tipos = Object.assign(response.data.tipos)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleOcupacaoChange(value) {
            this.$emit('cleaned', [])

            this.form.especialidades = []
            this.form.usuarios = []
            this.form.tipos = []
            this.form.status = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.tipoId = null
            this.model.statusId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'especialidades',
                pacienteId: this.pacienteId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: value,
            }

            this.setLoading()

            this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.tipos = Object.assign(response.data.tipos)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.$emit('cleaned', [])

            this.form.usuarios = []
            this.form.tipos = []
            this.form.status = []
            this.model.usuarioId = null
            this.model.tipoId = null
            this.model.statusId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'usuarios',
                pacienteId: this.pacienteId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: value,
            }

            this.setLoading()

            this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.tipos = Object.assign(response.data.tipos)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.$emit('cleaned', [])

            this.form.tipos = []
            this.form.status = []
            this.model.tipoId = null
            this.model.statusId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'jornada-vaga-tipos',
                pacienteId: this.pacienteId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.tipos = Object.assign(response.data.tipos)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleJornadaVagaTipoChange(value) {
            this.$emit('cleaned', [])

            this.form.status = []
            this.model.statusId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'status',
                pacienteId: this.pacienteId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                tipoId: value,
            }

            this.setLoading()

            this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleStatusChange() {
            this.$emit('cleaned', [])
        },
        search() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        pacienteId: this.pacienteId,
                        periodo: {
                            start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                            end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                        },
                        inicio: this.model.inicio,
                        fim: this.model.fim,
                        unidadeId: this.model.unidadeId,
                        infraestruturaId: this.model.infraestruturaId,
                        ocupacaoId: this.model.ocupacaoId,
                        especialidadeId: this.model.especialidadeId,
                        usuarioId: this.model.usuarioId,
                        tipoId: this.model.tipoId,
                        statusId: this.model.statusId,
                    }

                    this.setLoading()

                    this.repositories.agendamento.index(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.$emit('searched', response.data.map(agendamento => ({...agendamento, selecionado: false})))
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        print() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        pacienteId: this.pacienteId,
                        periodo: {
                            start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                            end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                        },
                        inicio: this.model.inicio,
                        fim: this.model.fim,
                        unidadeId: this.model.unidadeId,
                        infraestruturaId: this.model.infraestruturaId,
                        ocupacaoId: this.model.ocupacaoId,
                        especialidadeId: this.model.especialidadeId,
                        usuarioId: this.model.usuarioId,
                        tipoId: this.model.tipoId,
                        statusId: this.model.statusId,
                    }

                    this.setLoading()

                    this.repositories.impressao.listaAgendamento(this.camelObjectKeysToSnakeRecursive(request))
                        .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                        .finally(() => this.unsetLoading())
                })
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.$emit('cleaned', [])

            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.tipos = []
            this.form.status = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.inicio = null
            this.model.fim = null

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.tipoId = null
            this.model.statusId = null

            this.$refs.RkmForm.resetValidator()
        },
    },
    mixins: [error, file, repository, stringCase],
    props: {
        form: {type: Object, required: true},
        model: {type: Object, required: true},
        pacienteId: {type: [Number, String], required: true},
    },
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.$emit('cleaned', [])

                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.ocupacoes = []
                this.form.especialidades = []
                this.form.usuarios = []
                this.form.tipos = []
                this.form.status = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.ocupacaoId = null
                this.model.especialidadeId = null
                this.model.usuarioId = null
                this.model.tipoId = null
                this.model.statusId = null

                if (value.start === null || value.end === null) return

                const request = {
                    origem: 'busca',
                    listar: 'unidades',
                    pacienteId: this.pacienteId,
                    periodo: {
                        start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                        end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                    },
                    inicio: this.model.inicio,
                    fim: this.model.fim,
                }

                this.setLoading()

                this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                        this.form.especialidades = Object.assign(response.data.especialidades)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.tipos = Object.assign(response.data.tipos)
                        this.form.status = Object.assign(response.data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>